export default __webpack_public_path__ + "static/media/Fajr_namaj.28446142.svg";